<template>
  <div class="EscuelaDetalleAlumnos">
    EscuelaDetalleAlumnos
  </div>
</template>
<script>
export default {
  name: "EscuelaDetalleAlumnos"
};
</script>